(()=>{
if(window.PARKHairtestFrame)return;
const loads=new WeakMap();
// srcdoc does not inherit the storefront's merchant and shared CTA tokens.
function themeTokens(){
 const source=getComputedStyle(document.documentElement), style=document.createElement('style');
 const tokens=['forrest','sage','cloud','mist','stone','rainy','radius','btn-radius','cta-height','cta-padding','cta-line-height','cta-font-size','cta-font-weight'];
 const declarations=tokens.map(name=>{const value=source.getPropertyValue('--park-'+name).trim();return value?'--park-'+name+':'+value+';':''}).join('');
 const button=document.querySelector('.park-hairtest-landing-copy .btn, .park-hairtest-card .btn');
 let actions='';
 if(button){
  const actual=getComputedStyle(button);
  const properties={'cta-font-size':'font-size','cta-font-weight':'font-weight','cta-line-height':'line-height','cta-padding':'padding','cta-height':'min-height','btn-radius':'border-top-left-radius'};
  actions=Object.entries(properties).map(([token,property])=>'--park-'+token+':'+actual.getPropertyValue(property)+';').join('');
 }
 style.textContent=':root{'+declarations+actions+'}';
 return style.outerHTML;
}
async function load(frame){
 if(loads.has(frame))return loads.get(frame);
 const task=(async()=>{try{
  const url=new URL(frame.getAttribute('data-park-frame-url'),location.origin);
  const id=new URL(location.href).searchParams.get('resultat_id')||new URL(location.href).searchParams.get('resultat');
  if(id)url.searchParams.set('resultat_id',id);
  const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw new Error('load');
  const html=new DOMParser().parseFromString(await response.text(),'text/html');
  const styles=Array.from(html.querySelectorAll('link[rel=stylesheet]')).filter(el=>/\/park-hairtest-(core|result|questions)\.css/.test(el.href)).map(el=>el.outerHTML).join('');
  const content=['#app','#announcement','[data-haartest]','#park-dev-icons','#park-hairtest-translations'].map(sel=>html.querySelector(sel)?.outerHTML||'').join('');
  const scripts=Array.from(html.querySelectorAll('script[src]')).filter(el=>/\/park-hairtest-(logic|result|api|questions)\.js/.test(el.src)).map(el=>el.outerHTML).join('');
  if(!html.querySelector('#app')||!scripts)throw new Error('markup');
  const language=document.createElement('html');language.lang=html.documentElement.lang||document.documentElement.lang;
  frame.srcdoc='<!doctype html>'+language.outerHTML.replace('</html>','')+'<head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">'+styles+themeTokens()+'</head><body class="embedded">'+content+scripts+'</body></html>';
 }catch(error){loads.delete(frame);const message=document.createElement('p');message.textContent=frame.getAttribute('data-load-error')||'';frame.srcdoc=message.outerHTML;}})();
 loads.set(frame,task);return task;
}
window.PARKHairtestFrame={load};
window.addEventListener('message',event=>{
 const frame=Array.from(document.querySelectorAll('[data-park-frame-url]')).find(f=>f.contentWindow===event.source);if(!frame||event.origin!==location.origin)return;
 if(event.data==='park-local-close')frame.closest('dialog')?.close();
 if(event.data?.type==='park:hairtest-result'&&/^[A-Za-z0-9_-]{16,128}$/.test(event.data.id)){const url=new URL(location.href);url.searchParams.set('resultat_id',event.data.id);history.replaceState({},'',url);}
});
})();